import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';

import '../components/visit-card-media-gallery.js';

function initVisitSwipers() {
    document.querySelectorAll('.swiper--auto').forEach((swiperEl) => {

        const nextEl = swiperEl.querySelector('.swiper__next');
        const prevEl = swiperEl.querySelector('.swiper__prev');
        const paginationEl = swiperEl.querySelector('.swiper__pagination-inner');
        const progressBar = swiperEl.querySelector('.swiper__progress-bar');

        new Swiper(swiperEl, {
            modules: [Navigation, Pagination, EffectFade, Autoplay],

            loop: true,
            speed: 800,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },

            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },

            navigation: {
                nextEl,
                prevEl,
            },

            pagination: {
                el: paginationEl,
                type: 'fraction',
                formatFractionCurrent: (number) => {
                    return number < 10 ? `0${number}` : number;
                },
                formatFractionTotal: (number) => {
                    return number < 10 ? `0${number}` : number;
                },
                renderFraction(currentClass, totalClass) {
                    return `
                        <span class="${currentClass}"></span>
                        <span>-</span>
                        <span class="${totalClass}"></span>
                    `;
                },
            },

            on: {
                init(swiper) {
                    const progressBar = swiper.el.querySelector('.swiper__progress-bar');

                    if (!progressBar) return;

                    const realSlidesCount = swiper.slides.filter(
                        slide => !slide.classList.contains('swiper-slide-duplicate')
                    ).length;

                    if (realSlidesCount <= 1) {
                        progressBar.parentElement.style.display = 'none';
                    }
                },

                autoplayTimeLeft(swiper, time, progress) {
                    const progressBar = swiper.el.querySelector('.swiper__progress-bar');
                    if (!progressBar) return;

                    progressBar.style.transform = `scaleX(${1 - progress})`;
                },
            },
        });
    });
}

function cardSwiper() {
    const alternateSwiper = new Swiper('.swiper--alt', {
        modules: [Navigation],

        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: false,
        watchOverflow: false,

        breakpoints: {
            // 768: {
            //     slidesPerView: 1.2,
            //     spaceBetween: 32,
            // },
            1025: {
                slidesPerView: 3,
                spaceBetween: 56,
            },
        },

        navigation: {
            nextEl: '.swiper__next--large',
            prevEl: '.swiper__prev--large',
        },

        on: {
            init: updateProgress,
            slideChange: updateProgress,
        },
    });

    function updateProgress(swiper) {
        const bar = swiper.el.querySelector('.swiper__progress-bar--black');
        if (!bar) return;

        const totalSteps = swiper.snapGrid.length;
        const currentStep = swiper.snapIndex + 1;

        const progress = currentStep / totalSteps;

        bar.style.transform = `scaleX(${progress})`;
        }

}

function reviewSwiper() {
    const alternateSwiper = new Swiper('.swiper--review', {
        modules: [Navigation],

        slidesPerView: 1.5,
        spaceBetween: 32,
        centeredSlides: false,
        watchOverflow: false,

        breakpoints: {
            // 768: {
            //     slidesPerView: 1.2,
            //     spaceBetween: 32,
            // },
            1025: {
                slidesPerView: 4,
                spaceBetween: 96,
            },
        },

        navigation: {
            nextEl: '.swiper__next--large',
            prevEl: '.swiper__prev--large',
        },

        on: {
            init: updateProgress,
            slideChange: updateProgress,
        },
    });

    function updateProgress(swiper) {
        const bar = swiper.el.querySelector('.swiper__progress-bar--black');
        if (!bar) return;

        const totalSteps = swiper.snapGrid.length;
        const currentStep = swiper.snapIndex + 1;

        const progress = currentStep / totalSteps;

        bar.style.transform = `scaleX(${progress})`;
    }

}

function cardModal() {
    document.addEventListener('show.bs.modal', function (event) {
    const card = event.relatedTarget;
    if (!card || !card.classList.contains('visit-card')) return;

    const modal = document.getElementById('visitModal');

    const title = card.dataset.title;
    const desc  = card.dataset.description;
    const img   = card.dataset.image;
    const dur   = card.dataset.duration;
    const price = card.dataset.price;
    const notice = card.dataset.notice;
    const reservation = card.dataset.reservation;
    const minutesLabel = card.dataset.minutesLabel;
    const freeLabel = card.dataset.freeLabel;
    const bookLabel = card.dataset.bookLabel;
    const bookLink = card.dataset.link;

    // IMAGE
    modal.querySelector('#modalImage').src = img || '';

    // TITLE
    modal.querySelector('#modalTitle').textContent = title || '';

    // DESCRIPTION
    modal.querySelector('#modalDescription').textContent = desc || '';

    if (reservation === 'book') {
    const linkHTML = `
        <a href="${bookLink}" class="theme-button theme-button--secondary-white visit-card__button target-blank" target="_blank" rel="noopener noreferrer noopener">
            <span class="theme-button__text">${bookLabel}</span>
        </a>
    `;
    modal.querySelector('#modalDescription').insertAdjacentHTML('beforeend', linkHTML);
}

    // META
    const meta = modal.querySelector('#modalMeta');
    meta.innerHTML = '';

    if (dur) {
        meta.innerHTML += `
        <div class="visit-card__icon-container">
            <svg class="visit-card__meta-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
            </svg>
        </div>
        <div class="visit-card__duration">
            ${dur} ${minutesLabel}
        </div>
        `;
    }

    meta.innerHTML += `
        <span class="visit-card__price">
        ${price ? `IDR ${Number(price).toLocaleString('id-ID')}` : freeLabel}
        </span>
    `;

    // FOOTER
    const footer = modal.querySelector('#modalFooter');
    footer.innerHTML = '';


    if (notice) {
        footer.innerHTML = `
        <div class="visit-card__notice">
        <div class="visit-card__icon-container">            
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96452 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7662 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM13.5 16.5C13.5 16.6989 13.421 16.8897 13.2803 17.0303C13.1397 17.171 12.9489 17.25 12.75 17.25C12.3522 17.25 11.9706 17.092 11.6893 16.8107C11.408 16.5294 11.25 16.1478 11.25 15.75V12C11.0511 12 10.8603 11.921 10.7197 11.7803C10.579 11.6397 10.5 11.4489 10.5 11.25C10.5 11.0511 10.579 10.8603 10.7197 10.7197C10.8603 10.579 11.0511 10.5 11.25 10.5C11.6478 10.5 12.0294 10.658 12.3107 10.9393C12.592 11.2206 12.75 11.6022 12.75 12V15.75C12.9489 15.75 13.1397 15.829 13.2803 15.9697C13.421 16.1103 13.5 16.3011 13.5 16.5ZM10.5 7.875C10.5 7.6525 10.566 7.43499 10.6896 7.24998C10.8132 7.06498 10.9889 6.92078 11.1945 6.83564C11.4001 6.75049 11.6263 6.72821 11.8445 6.77162C12.0627 6.81502 12.2632 6.92217 12.4205 7.0795C12.5778 7.23684 12.685 7.43729 12.7284 7.65552C12.7718 7.87375 12.7495 8.09995 12.6644 8.30552C12.5792 8.51109 12.435 8.68679 12.25 8.8104C12.065 8.93402 11.8475 9 11.625 9C11.3266 9 11.0405 8.88147 10.8295 8.6705C10.6185 8.45952 10.5 8.17337 10.5 7.875Z" fill="white"/>
            </svg>
        </div>
        ${notice}
        </div>
        `;
    }
    });

}

function stopPropagation(e) {
document.querySelectorAll('.visit-card__button')
  .forEach(el => {
    el.addEventListener('click', e => e.stopPropagation());
  });
}

document.addEventListener('DOMContentLoaded', 
    initVisitSwipers(),
    cardSwiper(),
    reviewSwiper(),
    cardModal(),
    stopPropagation(),
);